var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "100px",
    height: "100px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#6a6a6a",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(9.84615,9.84615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.09375,0.25c-0.59375,-0.00391 -1.17578,0.20703 -1.625,0.65625l-1,1.03125l6.59375,6.625l1,-1.03125c0.90234,-0.90234 0.91016,-2.36719 0,-3.28125l-3.3125,-3.3125c-0.45703,-0.45703 -1.0625,-0.68359 -1.65625,-0.6875zM16.34375,2.84375l-1.5625,1.5l6.875,6.875l1.59375,-1.46875zM13.78125,5.4375l-10.8125,10.71875c-0.25,0.12891 -0.42969,0.35547 -0.5,0.625l-2.3125,7.84375c-0.10547,0.34375 -0.01172,0.72266 0.24219,0.97656c0.25391,0.25391 0.63281,0.34766 0.97656,0.24219l7.84375,-2.3125c0.36328,-0.05469 0.66406,-0.30859 0.78125,-0.65625l10.65625,-10.5625l-1.46875,-1.46875l-10.9375,10.96875l-4.40625,1.28125l-0.9375,-0.9375l1.34375,-4.59375l10.84375,-10.8125zM16.15625,7.84375l-10.96875,11l1.59375,0.34375l0.21875,1.46875l11,-10.96875z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.28014b3000a29928df27a789d3171fd7.svg";
export { ForwardRef as ReactComponent };